export const Brand_Giphy = `<svg title="Brand_Giphy" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="24" height="24" fill="#161613"/>
<mask id="mask0_3149_22" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="6" y="4" width="12" height="16">
<path d="M17.8333 4.50001H6.16663V19.5H17.8333V4.50001Z" fill="white"/>
</mask>
<g mask="url(#mask0_3149_22)">
<path d="M7.83329 5.83334H6.16663V18.1667H7.83329V5.83334Z" fill="#00FF99"/>
<path d="M17.8334 9.16668H16.1668V18.1667H17.8334V9.16668Z" fill="#9933FF"/>
<path d="M17.8333 17.8334H6.16663V19.5H17.8333V17.8334Z" fill="#00CCFF"/>
<path d="M12.8333 4.50001H6.16663V6.16668H12.8333V4.50001Z" fill="#FFF35C"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.1666 7.83334V6.16668H14.5V4.50001H12.8333V6.17734V6.17985V7.84151V7.84401V9.50001H14.5018H16.1644H17.8333V7.83334H16.1666Z" fill="#FF6666"/>
<path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M12.8333 4.50001V6.16668H11.1645L12.8333 4.50001Z" fill="#0F0F0F"/>
<path opacity="0.4" fill-rule="evenodd" clip-rule="evenodd" d="M16.1668 11.1801V9.50001H17.8313L16.1668 11.1801Z" fill="#0F0F0F"/>
</g>
</svg>`;